import CHATED from '../../../helpers/chated-client';
import {
	GET_SHOPIFY_OAUTH_URL,
	ERROR_SHOPIFY_OAUTH_URL
} from '../../../constants';

export function downloadShopifyOAuthUrl(retryCount, shop) {
	return async (dispatch) => {
		const response = await CHATED.shopify.downloadOAuthUrl({
			shop
		});

		if (response.meta.code !== 200) {
			if (retryCount === 10) {
				dispatch({
					type: ERROR_SHOPIFY_OAUTH_URL,
					meta: response.meta
				});
				return;
			}

			dispatch(downloadShopifyOAuthUrl(retryCount++, shop));
			return;
		}

		dispatch({
			type: GET_SHOPIFY_OAUTH_URL,
			shopifyOAuthUrl: response.data.auth_url,
			meta: response.meta
		});
	};
}



// WEBPACK FOOTER //
// ./src/containers/auth-shopify-page/actions/index.js